// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"da35ec84","404":"783ccf07","498":"1adfeb4d"}[chunkId] + ".chunk.js";
};